import React from 'react';

import ConfigTablePage from '../../../components/ConfigTablePage';
import RoomForm from '../../../components/RoomForm';
import { listRooms, deleteRoom } from '../../../api';

const COLUMNS = [
  { label: 'Identifier', width: 'minmax(170px, 1fr)', minWidth: 170, render: (r) => r.getIdentifier() },
  { label: 'Floor', width: '120px', minWidth: 120, render: (r) => r.getFloor()?.getIdentifier() },
  { label: 'Status', width: '140px', minWidth: 140, render: (r) => r.getAlertStatus()?.getDashboardStatus() }
];

export default function Rooms() {
  return (
    <ConfigTablePage
      title='Rooms'
      singular='room'
      columns={COLUMNS}
      load={listRooms}
      idOf={(r) => r.getID()}
      searchText={(r) => [r.getIdentifier(), r.getFloor()?.getIdentifier()].filter(Boolean).join(' ')}
      searchPlaceholder='Search room'
      renderForm={(row, onSaved) => <RoomForm room={row ?? undefined} onSuccess={onSaved} hideDelete />}
      dialogWidth={960}
      remove={(row) => deleteRoom(row.getID())}
      deleteTitle={(row) => 'Delete room ' + row.getIdentifier() + '?'}
      deleteBody='The room will no longer exist.'
      deleted={(row) => 'Room ' + row.getIdentifier() + ' deleted.'}
    />
  );
}
